{
  "$schema": "./schema.json",
  "formFields": {
    "companyLabel": "Your company",
    "companyPlaceholder": {
      "SE": "Search company name or org. no.",
      "FI": "Search company name or Business ID"
    },
    "companyErrors": {
      "orgNumberRequired": "Organisation number is required",
      "orgNumberInvalid": "Enter a valid organisation number",
      "orgNameRequired": "Organisation name is required"
    },
    "companyFindHelp": "Can't find your company? Enter your organisation number.",
    "companyPreloader": "Searching...",
    "companyChange": "Change",
    "companySelect": "Select",
    "emailLabel": "Email",
    "emailPlaceholder": {
      "SE": "contact@company.se",
      "FI": "contact@company.fi"
    },
    "emailErrors": {
      "invalid": "Invalid email",
      "required": "Email is required",
      "validationError": "Please enter a valid e-mail address"
    },
    "phoneLabel": "Mobile phone number",
    "phonePlaceholder": {
      "SE": "070 000 00 00",
      "FI": "050 0000 000"
    },
    "phoneErrors": {
      "invalid": "Phone number is invalid",
      "required": "Phone number is required"
    },
    "amountLabel": "Desired financing",
    "limitedCompanyConfirmation": "Limited company",
    "requestedAmountErrors": {
      "typeError": "Use numbers only",
      "required": "Choose amount"
    },
    "consentError": "You have to approve that we process your personal data",
    "privacyPolicyConsent": "I accept that {{company}} is processing my <1>personal data</1>",
    "minimumAmountError": "The minimum amount to apply for is {{amount}}"
  }
}
